/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tracking_Playback_Max_RangeInputs */

const vi_tracking_playback_max_range = /** @type {(inputs: Tracking_Playback_Max_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khoảng thời gian tối đa là 7 ngày`)
};

/**

* @param {Tracking_Playback_Max_RangeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tracking_playback_max_range = /** @type {((inputs?: Tracking_Playback_Max_RangeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tracking_Playback_Max_RangeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tracking_playback_max_range(inputs)
});